import { useNode, useEditor } from "@craftjs/core";
import React, { useState, useEffect, useContext } from "react";
import { RichTextInput } from "../../input";
import SVGIcons from "../../input/icons.json";
import GrigoraCSSRenderer from "./../css-render";
import SVG from "react-inlinesvg";
import { ButtonSettings } from "./settings";
import icon from "./icon";
import { CMSButtonSettings } from "./cms-settings";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import CMSIcon from "./cms-icon";
import Toast from "../../toast/toast";
import { CorrectIcon } from "../../../assets/ui-icons";
import { toast } from "react-toastify";
import { GrigoraDashboardContext } from "../../dashboard/context";
import { GrigoraEditorContext } from "../../editor/context";

export const Button = (props) => {
  const { screen, domain, cmsPosts } =
    useContext(GrigoraDashboardContext) ?? {};
  const {
    id,
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    query: { node },
    actions: { selectNode },
  } = useEditor();

  const {
    icon,
    customIcon,
    hasCustomIcon,
    link,
    openInNewTab,
    text,
    iconPosition = "left",
    dynamicLink = false,
    dynamicLinkSrc,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-button": true,
      [`button-${id}`]: id,
    },
    blockProps.className,
  );

  return (
    <div
      {...blockProps}
      {...(screen === "cms-post-editor"
        ? { ref: (ref) => connect(ref) }
        : { ref: (ref) => connect(drag(ref)) })}
      className={wrapperClass}
      onFocus={() => {
        selectNode(id);
      }}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__Button(id, props)}`}</style>
      <a
        onClick={(e) => {
          e.preventDefault();
        }}
        href={
          dynamicLink && dynamicLinkSrc
            ? `https://${domain}/${dynamicLinkSrc}`
            : link
            ? `${link}`
            : "#"
        }
        target={openInNewTab ? `_blank` : `_self`}
      >
        <div className="btn">
          {iconPosition === "left" ? (
            hasCustomIcon && customIcon !== "" ? (
              <SVG src={customIcon} />
            ) : (
              <>
                {icon && SVGIcons[icon] && (
                  <SVG title={icon} src={SVGIcons[icon]} />
                )}
              </>
            )
          ) : (
            ""
          )}
          <RichTextInput
            value={text}
            onChange={(e) => setProp((props) => (props.text = e), 500)}
            tagName="span"
            linkNotAllowed={true}
            onLinkPaste={(url) => {
              if (!url) {
                return;
              }

              if (url.href) {
                setProp((props) => (props.link = url.href), 500);

                toast.success(<Toast title={"Link Applied To Button"} />, {
                  icon: <CorrectIcon />,
                });
              }
            }}
          />
          {iconPosition === "right" ? (
            hasCustomIcon && customIcon !== "" ? (
              <SVG src={customIcon} />
            ) : (
              <>
                {icon && SVGIcons[icon] && (
                  <SVG title={icon} src={SVGIcons[icon]} />
                )}
              </>
            )
          ) : (
            ""
          )}
        </div>
      </a>
    </div>
  );
};

// To Avoid Mangling in Production
Button.displayName = "Button";

Button.craft = {
  name: "Button",
  props: {},
  related: {
    icon: icon,
    CMSIcon: CMSIcon,
    category: "basic",
    supports: [
      "grigora/directory-conditional",
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    settings: ButtonSettings,
    CMSsettings: CMSButtonSettings,
    keywords: ["Button", "On Click", "Call to Action"],
  },
  custom: {
    name: "Button",
    slug: "grigora/button",
  },
};
